import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { BasicTemplateWrapper } from 'src/default/templates'
import { NotificationConsentView } from 'src/v2/domains/notification/views/NotificationConsent.view'
import { useCrossOrganizationNavigationGuard } from 'src/v2/domains/organization/hooks/useCrossOrganizationNavigationGuard.hook'

import RouteChunkErrorBoundary from '@v2/commons/components/PageLoadRecovery/RouteChunkErrorBoundary.component'
import NavigationManager from '@v2/domains/routing/components/NavigationManager'

const AppLayout = () => {
  const location = useLocation()
  const { shouldBlockRendering } = useCrossOrganizationNavigationGuard()

  const isFormBuilder = location.pathname.includes('/form-builder')

  if (shouldBlockRendering) {
    return (
      <>
        <NavigationManager />
      </>
    )
  }

  if (isFormBuilder) {
    return (
      <>
        <NavigationManager />
        <RouteChunkErrorBoundary>
          <Outlet />
        </RouteChunkErrorBoundary>
        <NotificationConsentView shouldBlockRendering={shouldBlockRendering} />
      </>
    )
  }

  return (
    <BasicTemplateWrapper>
      <NavigationManager />
      <RouteChunkErrorBoundary>
        <Outlet />
      </RouteChunkErrorBoundary>
      <NotificationConsentView shouldBlockRendering={shouldBlockRendering} />
    </BasicTemplateWrapper>
  )
}

export default AppLayout
